export const rolesList = ['Planning Admin', 'Master Data', 'Planning', 'Warehouse'];
export const statusList = ['Active', 'Inactive', 'All'];
export const organisationsList = [
  {
    orgRef: 'PRD',
    orgDescription: 'WM Morrisons Produce',
  },
  {
    orgRef: 'WHD',
    orgDescription: 'Woodheads',
  },
  {
    orgRef: 'ISL',
    orgDescription: 'International Seafoods',
  },
  {
    orgRef: 'SFL',
    orgDescription: 'Simply Fresh',
  },
  {
    orgRef: 'RBL',
    orgDescription: 'Rathbones',
  },
  {
    orgRef: 'FBG',
    orgDescription: 'Farmers Boy Greenside',
  },
  {
    orgRef: 'FBD',
    orgDescription: 'Farmers Boy Deeside',
  },
  {
    orgRef: 'FBW',
    orgDescription: 'Farmers Boy Winsford',
  },
  {
    orgRef: 'LLN',
    orgDescription: 'Lowlands',
  },
  {
    orgRef: 'FLW',
    orgDescription: 'Flowerworld',
  },
];

export const roles = ['planning admin', 'planning', 'master', 'warehouse'];
